export enum ModalTypesEnum {
    VIDEO = 'video',
    RATING = 'rating',
    FACT_CHECK = 'fact-check',
}
